import type { TranslationDict } from '../en';

const et: TranslationDict = {
  // ─── Header ───
  'header.buy': 'Osta',
  'header.sell': 'Müü',

  // ─── SpendCard ───
  'spend.label': 'Sa kulutad',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'Sa saad',

  // ─── PaymentCard ───
  'payment.label': 'Makseviis',
  'payment.select': 'Vali',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Sellele paarile pole makseviise saadaval',

  // ─── WalletCard ───
  'wallet.label': 'Vastuvõtva rahakoti aadress',
  'wallet.placeholderBuy': 'Sisesta vastuvõtuaadress',
  'wallet.placeholderSell': 'Sisesta saatmisaadress',
  'wallet.validating': 'Aadressi kontrollimine...',
  'wallet.invalid': 'Sisesta kehtiv rahakoti aadress',
  'wallet.invalidServer': 'Sobimatu rahakoti aadress',

  // ─── CtaButton ───
  'cta.buy': 'Osta {crypto}',
  'cta.sell': 'Müü {crypto}',
  'cta.gettingPrice': 'Parima hinna otsimine...',
  'cta.processing': 'Töötlemine...',

  // ─── Footer ───
  'footer.poweredBy': 'Toetab ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'Kursi ülevaade',
  'rate.close': 'Sulge',
  'rate.updatesIn': 'Kurss uueneb 00:{seconds} pärast',
  'rate.noQuote': 'Hinnapakkumine puudub',
  'rate.exchangeRate': 'Vahetuskurss',
  'rate.processingFee': 'Töötlemistasu',
  'rate.networkFee': 'Võrgutasu',
  'rate.provider': 'Teenusepakkuja',

  // ─── Toast ───
  'toast.orderCreated': 'Tellimus loodud',
  'toast.redirecting': 'Suunamine kassasse...',
  'toast.orderFailed': 'Tellimus ebaõnnestus',
  'toast.couldNotCreate': 'Tellimust ei õnnestunud luua',
  'toast.quoteError': 'Hinnapakkumise viga',
  'toast.noProviders': 'Teenusepakkujad puuduvad',
  'toast.somethingWrong': 'Midagi läks valesti',

  // ─── Form errors ───
  'error.amountZero': 'Summa peab olema suurem kui 0',
  'error.minAmountFiat': 'Miinimumsumma on {min} {currency}',
  'error.minAmountCrypto': 'Miinimumsumma on {min} {currency}',
  'error.noProviders': 'Selle kombinatsiooni jaoks pole teenusepakkujaid saadaval',
  'error.currencyUnavailableBuy': 'See valuuta ei ole ostutellimuste jaoks saadaval',
  'error.currencyUnavailableSell': 'See valuuta ei ole müügitellimuste jaoks saadaval',

  // ─── Parity banner ───
  'parity.info': 'Teilt võetakse {receiveAmount} {crypto}, ülejäänud kuni {spendAmount} {fiat} krediteeritakse teie {partner} kontole',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'Turvaline makse',
  'redirect.title': 'Jätka maksmist',
  'redirect.description': 'Teid suunatakse {gateway} lehele makse lõpuleviimiseks.',
  'redirect.countdown': 'Suunamine {seconds} sekundi pärast...',
  'redirect.openTab': 'Ava ACH uuel vahelehel',
  'redirect.cancel': 'Tühista',

  // ─── Checkout Step ───
  'checkout.noOrder': 'Tellimust ei leitud',
  'checkout.goBack': 'Mine tagasi',
  'checkout.expired': 'Kassa aegus',
  'checkout.expiredDesc': 'Seanss on aegunud. Palun proovige uuesti.',
  'checkout.startOver': 'Alusta uuesti',
  'checkout.cancel': 'Tühista',
  'checkout.loading': 'Kassa laadimine...',
  'checkout.iframeTitle': 'Teenusepakkuja kassa',
  'checkout.widgetTitle': 'Makse kassa',
  'checkout.unknownMethod': 'Tundmatu kassaviis',

  // ─── Processing Step ───
  'processing.default': 'Teie tellimust töödeldakse...',
  'processing.pending': 'Makse kinnituse ootamine...',
  'processing.active': 'Teie tehingut töödeldakse...',
  'processing.generic': 'Töötlemine...',
  'processing.checkingStatus': 'Oleku kontrollimine...',
  'processing.orderId': 'Tellimuse ID',
  'processing.provider': 'Teenusepakkuja',
  'processing.amount': 'Summa',
  'processing.receiving': 'Vastuvõtmine',
  'processing.network': 'Võrk',
  'processing.toAddress': 'Sihtaadress',
  'processing.usuallyMinutes': 'See võtab tavaliselt mõne minuti.',
  'processing.safeToClose': 'Võite selle lehe julgelt sulgeda – saadame teile meili, kui kõik on valmis.',

  // ─── Complete Step ───
  'complete.buyTitle': 'Ost lõpetatud!',
  'complete.sellTitle': 'Müük lõpetatud!',
  'complete.buyDesc': 'Teie {crypto} on teie rahakotti saadetud.',
  'complete.sellDesc': 'Teie {fiat} väljamakset töödeldakse.',
  'complete.amountBuy': 'Saadud summa',
  'complete.amountSell': 'Müüdud summa',
  'complete.paidBuy': 'Makstud summa',
  'complete.paidSell': 'Väljamakse summa',
  'complete.network': 'Võrk',
  'complete.wallet': 'Rahakott',
  'complete.transaction': 'Tehing',
  'complete.provider': 'Teenusepakkuja',
  'complete.orderId': 'Tellimuse ID',
  'complete.completed': 'Lõpetatud',
  'complete.viewExplorer': 'Vaata plokiahelas',
  'complete.done': 'Valmis',

  // ─── Error Step ───
  'errorStep.failed': 'Makse ebaõnnestus',
  'errorStep.cancelled': 'Tellimus tühistatud',
  'errorStep.expired': 'Tellimus aegunud',
  'errorStep.refunded': 'Tellimus tagastatud',
  'errorStep.unknown': 'Midagi läks valesti',
  'errorStep.failedBuy': 'Teie makset ei õnnestunud töödelda. Palun proovige uuesti või kasutage mõnda muud makseviisi.',
  'errorStep.failedSell': 'Teie müüki ei õnnestunud töödelda. Palun proovige uuesti.',
  'errorStep.cancelledBuy': 'Teie tellimus tühistati. Ühtegi makset ei töödeldud.',
  'errorStep.cancelledSell': 'Teie müük tühistati. Ühtegi krüptot ei edastatud.',
  'errorStep.expiredBuy': 'Teie tellimus on aegunud. Palun alustage uut ostu.',
  'errorStep.expiredSell': 'Teie tellimus on aegunud. Palun alustage uut müüki.',
  'errorStep.refundedBuy': 'Teie makse on tagastatud. Raha peaks ilmuma teie kontole 5–10 tööpäeva jooksul.',
  'errorStep.refundedSell': 'Teie krüpto on tagastatud. Raha peaks varsti teie rahakotti ilmuma.',
  'errorStep.genericDesc': 'Ilmnes ootamatu viga. Palun proovige uuesti.',
  'errorStep.orderId': 'Tellimuse ID',
  'errorStep.tryAgain': 'Proovi uuesti',
  'errorStep.startOver': 'Alusta uuesti',
  'errorStep.return': 'Tagasi',
  'errorStep.needHelp': 'Vajad abi? Võta ühendust ',
  'errorStep.reference': 'Viide: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'Kinnita ost',
  'confirm.sellTitle': 'Kinnita müük',
  'confirm.loading': 'Laadimine...',
  'confirm.provider': 'Teenusepakkuja',
  'confirm.youPay': 'Sa maksad',
  'confirm.youSell': 'Sa müüd',
  'confirm.youReceive': 'Sa saad',
  'confirm.wallet': 'Rahakott',
  'confirm.network': 'Võrk',
  'confirm.refundAddress': 'Tagastusaadress',
  'confirm.parityNote': 'Teenusepakkuja arvestatud summa võib erineda. Ülejäänud kuni {amount} {crypto} krediteeritakse teie {partner} kontole.',
  'confirm.processing': 'Töötlemine...',
  'confirm.confirmPay': 'Kinnita ja maksa',
  'confirm.confirmSell': 'Kinnita ja müü',
  'confirm.payout': '{currency} väljamakse',

  // ─── Modals ───
  'modal.selectFiat': 'Vali fiat-valuuta',
  'modal.selectCrypto': 'Vali krüptovaluuta',
  'modal.choosePayment': 'Vali makseviis',
  'modal.selectCountry': 'Vali oma riik',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populaarne',
  'modal.recommended': 'Soovitatav',
  'modal.noCurrencies': 'Valuutasid ei leitud',
  'modal.noPaymentMethods': 'Makseviise ei leitud',
  'modal.noCountries': 'Riike ei leitud',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'Asukoht',
  'settings.darkMode': 'Tume režiim',
  'settings.privacy': 'Privaatsuspoliitika',
  'settings.terms': 'Kasutustingimused',
  'settings.language': 'Keel',

  // ─── Additional ───
  'modal.chooseRamp': 'Vali Ramp',
  'modal.bestPrice': 'Parim hind',
  'modal.noQuotes': 'Selle päringu jaoks pole hinnapakkumisi saadaval',
  'modal.noProvidersFound': 'Teenusepakkujaid ei leitud',
  'payment.unavailableFor': '{currency} jaoks pole makseviise saadaval',
  'skeleton.poweredBy': 'Toetab NowRamp',
  'error.createOrderFailed': 'Tellimuse loomine ebaõnnestus',
  'errorStep.returnToMerchant': 'Tagasi kauplejale',
  'confirm.cryptoOnNetwork': '{crypto} {network} võrgus',
  'payment.name.card': 'Kaart',
  'payment.name.bankTransfer': 'Pangaülekanne',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default et;
